import { Alert, AlertAction } from '@app/redux/alerts';

export const useResumeServiceAlertIdentification = (alert: Alert) => {
  return alert.button?.action === AlertAction.ResumeService;
};
